module.exports = __webpack_public_path__ + "img/bg.445639f6.png";